import { Keypair, PublicKey, StakeProgram, VersionedTransaction, Authorized } from '@solana/web3.js';
import { getMinRent } from '@/helpers/solana/getMintRent';
import { prepareTransaction } from '@/helpers/solana/prepareTransaction';
import { validatorAccount } from '@/constants';

export async function prepareStakeTransaction(
  fromPubkey: PublicKey,
  lamports: number,
): Promise<VersionedTransaction> {
  let stakeAccount = Keypair.generate();

  const minRent = await getMinRent();
  const createStakeAccountTx = StakeProgram.createAccount({
    authorized: new Authorized(fromPubkey, fromPubkey),
    fromPubkey: fromPubkey,
    lamports: lamports + minRent,
    stakePubkey: stakeAccount.publicKey,
  });
  const delegateTx = StakeProgram.delegate({
    stakePubkey: stakeAccount.publicKey,
    authorizedPubkey: fromPubkey,
    votePubkey: new PublicKey(validatorAccount),
  });
  const createAndDelegateTx = createStakeAccountTx.add(delegateTx);

  const tx = await prepareTransaction(
    createAndDelegateTx.instructions,
    fromPubkey,
  );
  tx.sign([stakeAccount]);
  return tx;
}
